import { MenuDivider } from "@blueprintjs/core"
import { groupBy, isEmpty } from "lodash-es"
import React, { createContext } from "react"
import { Link, useNavigate, useLocation } from "react-router-dom"
import logo from "assets/images/logo_ios.png"
import { SubNavItem } from "./sidebar-item"
const AppSidebarContext = createContext()
const SideBarLogo = ({ children }) => (
  <Link
    className="h-16 w-16 flex justify-center items-center hover:opacity-80 vt-logo-brand"
    to={"/d"}
  >
    <span className="bg-white rounded h-10 w-10">
      <img alt="VesatoGo" src={logo} className="h-10 w-10" />
    </span>
    {children ? children : null}
  </Link>
)
const AppSidebar = ({ children }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleSelect = path => {
    if (location.pathname !== path) {
      navigate(path)
    }
  }
  return (
    <div className="vt-sidebar">
      <SideBarLogo />
      <AppSidebarContext.Provider value={{ onSelect: handleSelect, location }}>
        {children}
      </AppSidebarContext.Provider>
    </div>
  )
}

const SubNav = ({ routes, parentPath }) => {
  const validSubroutes = groupBy(routes, "type")
  return (
    <>
      {isEmpty(validSubroutes)
        ? null
        : Object.keys(validSubroutes).map((vs, idx) => {
            return (
              <React.Fragment key={idx}>
                {vs && vs !== "undefined" && (
                  <MenuDivider key={vs} title={vs} />
                )}
                {validSubroutes?.[vs]?.map(sr => {
                  return (
                    <SubNavItem
                      parentPath={parentPath}
                      key={sr.path}
                      path={sr.path}
                      text={sr.title}
                      icon={sr.icon}
                    />
                  )
                })}
              </React.Fragment>
            )
          })}
    </>
  )
}
export default AppSidebar
export { AppSidebarContext, SubNav, SideBarLogo }
